
import { Project } from "./types";

export const projects: Project[] = [
  {
    id: 1,
    title: "Vibe-Booking",
    category: "Web App",
    description: "A modern hotel booking platform with advanced search capabilities, date selection, guest management, and environment preferences. Features a clean, intuitive interface with real-time availability and booking management.",
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=1800&auto=format",
    tags: ["React", "TypeScript", "Tailwind CSS", "Date Picker"]
  },
  {
    id: 2,
    title: "Vibe-Rentals",
    category: "Web App",
    description: "A comprehensive rental property listing platform where landlords can list properties free of charge and renters can discover perfect rental properties that match their lifestyle. Features advanced search, property browsing, and listing management.",
    image: "/lovable-uploads/0930ed3b-7a63-492d-87c3-9a547af4aa27.png",
    tags: ["React", "TypeScript", "Property Search", "Rental Management"]
  },
  {
    id: 3,
    title: "AI SaaS Dashboard",
    category: "Web App",
    description: "Enterprise-grade SaaS platform with AI-powered analytics, machine learning insights, and predictive business intelligence. Features real-time data processing, custom reporting, and advanced user management with role-based access control.",
    image: "/custom-images/ai-saas-dashboard.jpg", // Your custom image path
    tags: ["React", "Python", "TensorFlow", "PostgreSQL", "Docker"]
  },
  {
    id: 4,
    title: "CryptoTrade Pro",
    category: "Web App", 
    description: "Professional cryptocurrency trading platform with real-time market data, advanced charting tools, automated trading bots, and portfolio management. Includes WebSocket integration for live price feeds and secure wallet management.",
    image: "/custom-images/crypto-trading-platform.jpg", // Your custom image path
    tags: ["React", "WebSocket", "Node.js", "Redis", "Blockchain API"]
  },
  {
    id: 5,
    title: "E-Commerce Marketplace",
    category: "Web App",
    description: "Multi-vendor e-commerce platform with advanced inventory management, payment processing, vendor dashboards, and customer analytics. Features include affiliate marketing integration, review systems, and mobile-responsive design.",
    image: "/custom-images/ecommerce-marketplace.jpg", // Your custom image path
    tags: ["Next.js", "Stripe", "MongoDB", "AWS", "Elasticsearch"]
  },
  {
    id: 6,
    title: "Social Media Manager",
    category: "Web App",
    description: "Comprehensive social media management tool for content scheduling, analytics tracking, audience engagement, and campaign optimization across multiple platforms. Includes AI-powered content suggestions and performance insights.",
    image: "/custom-images/social-media-manager.jpg", // Your custom image path
    tags: ["Vue.js", "Python", "API Integration", "Chart.js", "AWS Lambda"]
  },
  {
    id: 7,
    title: "PropTech Platform",
    category: "Web App",
    description: "Revolutionary real estate platform with virtual property tours, AR visualization, smart contracts integration, and IoT property monitoring. Features advanced search algorithms and predictive market analysis.",
    image: "/custom-images/proptech-platform.jpg", // Your custom image path
    tags: ["React", "Three.js", "Blockchain", "AR/VR", "Smart Contracts"]
  },
  {
    id: 8,
    title: "FoodTech Delivery",
    category: "Mobile App",
    description: "Next-generation food delivery app with AI-powered recommendations, real-time tracking, dynamic pricing, and integrated payment systems. Features include restaurant partner dashboards and customer loyalty programs.",
    image: "/custom-images/foodtech-delivery.jpg", // Your custom image path
    tags: ["React Native", "GraphQL", "Microservices", "Google Maps", "Push Notifications"]
  },
  {
    id: 9,
    title: "FitnessTech PWA",
    category: "Mobile App",
    description: "Progressive Web App for comprehensive fitness tracking with wearable integration, personalized workout plans, nutrition tracking, and social fitness challenges. Includes offline functionality and health data synchronization.",
    image: "/custom-images/fitness-pwa.jpg", // Your custom image path
    tags: ["PWA", "Web Bluetooth", "IndexedDB", "Service Workers", "Health APIs"]
  },
  {
    id: 10,
    title: "EduTech LMS",
    category: "Web App",
    description: "Advanced Learning Management System with interactive video streaming, virtual classrooms, AI-powered assessments, and progress analytics. Features include peer-to-peer learning, certification management, and mobile learning support.",
    image: "/custom-images/edutech-lms.jpg", // Your custom image path
    tags: ["React", "WebRTC", "Video Streaming", "AI/ML", "Microlearning"]
  },
  {
    id: 11,
    title: "Quantum Computing Simulator",
    category: "Web App",
    description: "Web-based quantum computing simulator with visual circuit design, algorithm testing, and educational resources. Features interactive quantum gate manipulation and real-time simulation results visualization.",
    image: "/custom-images/quantum-simulator.jpg", // Your custom image path
    tags: ["JavaScript", "WebGL", "Quantum.js", "Three.js", "Educational"]
  },
  {
    id: 12,
    title: "Neon Dashboard",
    category: "Web App",
    description: "A modern analytics dashboard with real-time data visualization features, AI-powered insights, and customizable widgets for enterprise performance monitoring.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1800&auto=format",
    tags: ["React", "TypeScript", "Tailwind CSS", "Chart.js"]
  }
];
